// Localização: frontend/src/components/Financeiro/AcessoRapidoFinanceiro.jsx
// Acesso Rápido às Funções do Módulo Financeiro

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
    TrendingUp, 
    TrendingDown, 
    History, 
    Settings,
    BarChart3
} from 'lucide-react';

/**
 * @component AcessoRapidoFinanceiro
 * @description Componente compacto para acesso rápido às funções do módulo financeiro
 */
const AcessoRapidoFinanceiro = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const quickActions = [
        { 
            path: '/financeiro/dashboard', 
            icon: BarChart3, 
            label: 'Dashboard',
            color: 'text-emerald-600',
            bgColor: 'bg-emerald-50',
            activeBgColor: 'bg-emerald-100',
            hoverColor: 'hover:bg-emerald-100'
        },
        { 
            path: '/financeiro/contas-receber', 
            icon: TrendingUp, 
            label: 'Contas a Receber',
            color: 'text-green-600',
            bgColor: 'bg-green-50',
            activeBgColor: 'bg-green-100',
            hoverColor: 'hover:bg-green-100'
        },
        { 
            path: '/financeiro/contas-pagar', 
            icon: TrendingDown, 
            label: 'Contas a Pagar',
            color: 'text-red-600',
            bgColor: 'bg-red-50',
            activeBgColor: 'bg-red-100',
            hoverColor: 'hover:bg-red-100'
        },
        { 
            path: '/financeiro/historico', 
            icon: History, 
            label: 'Histórico',
            color: 'text-purple-600',
            bgColor: 'bg-purple-50',
            activeBgColor: 'bg-purple-100',
            hoverColor: 'hover:bg-purple-100'
        },
        { 
            path: '/financeiro/configuracoes', 
            icon: Settings, 
            label: 'Configurações',
            color: 'text-blue-600',
            bgColor: 'bg-blue-50',
            activeBgColor: 'bg-blue-100',
            hoverColor: 'hover:bg-blue-100'
        }
    ];

    return (
        <div className="bg-white/50 hover:bg-white/80 backdrop-blur-sm border border-gray-200 rounded-lg shadow-sm py-2 px-2 sm:py-3 sm:px-4 lg:px-8 transition-all duration-300 mb-4 relative z-[25]">
            <div className="w-full flex justify-center">
                <div className="flex gap-2 sm:gap-3 justify-center items-stretch flex-nowrap overflow-x-auto scrollbar-hide -mx-2 px-2 sm:mx-0 sm:px-0">
                    {quickActions.map((action) => {
                        const Icon = action.icon;
                        const isActive = location.pathname === action.path || 
                            (action.path !== '/financeiro/dashboard' && location.pathname.startsWith(action.path));
                        
                        return (
                            <button
                                key={action.path}
                                onClick={() => navigate(action.path)}
                                className={`
                                    flex items-center justify-center gap-1.5 sm:gap-2 
                                    px-2.5 py-2 sm:px-4 sm:py-3 rounded-lg
                                    transition-all duration-200 font-medium 
                                    text-xs sm:text-sm
                                    border shadow-sm hover:shadow-md
                                    h-[40px] sm:h-[44px] flex-shrink-0
                                    ${isActive 
                                        ? `${action.activeBgColor} ${action.color} border-current border-[0.5px] shadow-md font-semibold` 
                                        : `${action.bgColor} ${action.color} ${action.hoverColor} border-transparent hover:border-current`
                                    }
                                `}
                            >
                                <Icon className={`h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 ${isActive ? 'scale-110' : ''} transition-transform`} />
                                <span className="whitespace-nowrap hidden sm:inline">{action.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default AcessoRapidoFinanceiro;

